import type { BadgeColor } from "@volca/ui/components/ui/badge";
import type { ReportBuild } from "@/profitability/types";

export const OUTCOME: Record<
  ReportBuild["status"],
  { label: string; color: BadgeColor }
> = {
  building: { label: "Building", color: "information" },
  built: { label: "Built", color: "success" },
  needs_input: { label: "Needs answers", color: "warning" },
  failed: { label: "Failed", color: "danger" },
  superseded: { label: "Replaced", color: "neutral" },
};

/** What a build produced: its version and the work it took, as items of a line. */
export const produced = (build: ReportBuild) =>
  [
    build.version ? `Version ${build.version.version_number}` : null,
    build.rounds ? `${build.rounds} rounds` : null,
    build.questions.length
      ? `${build.questions.length} ${build.questions.length === 1 ? "question" : "questions"}`
      : null,
  ].filter((part) => part !== null);
